import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import AwardsPage from "./pages/AwardsPage";
import AwardDetailPage from "./pages/AwardDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminDashboard from "./pages/AdminDashboard";
import NominationsPage from "./pages/NominationsPage";
import UserDashboard from "./pages/UserDashboard";
import PartnerProfilePage from "./pages/PartnerProfilePage";
import Winners2021Page from "./pages/Winners2021Page";
import TwblAwardsPage from "./pages/TwblAwardsPage";
import MethodologyPage from "./pages/MethodologyPage";

// Layout
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Protected Route Component
function ProtectedRoute({ children, adminOnly = false, partnerOnly = false }) {
  const { user, loading, isAdmin, isPartner } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-12 h-12 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (partnerOnly && !isPartner && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/awards" element={<AwardsPage />} />
        <Route path="/awards/:id" element={<AwardDetailPage />} />
        <Route path="/winners/2021" element={<Winners2021Page />} />
        <Route path="/twblawards" element={<TwblAwardsPage />} />
        <Route path="/methodology" element={<MethodologyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/nominate" element={<NominationsPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/profile"
          element={
            <ProtectedRoute partnerOnly>
              <PartnerProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
